/**
 * localStorage wrapper: centralizes JSON (de)serialization, error handling
 * and key prefixing, to keep storage access uniform across the app.
 */

const prefixedKey = (key: string): string => `ef_${key}`;

export const get = <T>(key: string): T | null => {
  try {
    const raw = localStorage.getItem(prefixedKey(key));
    return raw === null ? null : (JSON.parse(raw) as T);
  } catch {
    console.warn(`localStorage: unreadable value for key "${key}"`);
    return null;
  }
};

export const set = (key: string, value: unknown): void => {
  try {
    localStorage.setItem(prefixedKey(key), JSON.stringify(value));
  } catch {
    console.warn(`localStorage: failed to write key "${key}"`);
  }
};

export const remove = (key: string): void => {
  localStorage.removeItem(prefixedKey(key));
};
